module.exports = __webpack_public_path__ + "img/hindbaer_cheesecake.f3155b40.jpg";